import { IAction } from '../../../types';
import { SET_PERFEED_RATING_SETTINGS } from '../../../actions/PerfeedActions';
import { Reducer } from 'react';

type RatingPointItemType = {
    id: number;
    date: string;
    name: string;
    message?: string;
    subjects: string[];
};

type RatingPointState = {
    link: string;
    qr: string;
    list: RatingPointItemType[];
};

const ratingPoint: Reducer<RatingPointState, IAction> = (
    state: RatingPointState = {
        link: 'https://survey.empfeed.com/perfeed/rating-point/list/361e5598433771440171284cb31d7cdc7de9af18',
        qr: '',
        list: [
            {
                id: 1,
                date: '2018-1-24T09:54',
                name: 'Meeting',
                message: 'Please give me feedback, thanks',
                subjects: [
                    'kvalita',
                    'odbornost',
                    'komunikace',
                    'prozákaznický přístup',
                ],
            },
            {
                id: 2,
                date: '2018-5-25T09:54',
                name: 'Meeting',
                subjects: [
                    'kvalita',
                    'odbornost',
                    'komunikace',
                    'prozákaznický přístup',
                ],
            },
        ],
    },
    action: IAction,
) => {
    switch (action.type) {
        case SET_PERFEED_RATING_SETTINGS:
            return action.payload;
        default:
            return state;
    }
};

export default ratingPoint;
